import React from "react";
import Layout from "../components/layout/WebLayout";
import PageTitle from "../assets/images/city-image-navigation.jpeg";
import TtsRed from "../assets/images/urunler/tts_red.jpg";
import ImgTTS from "../assets/images/tts-icon-nobg.png";

export default function Avantajlar() {
  return (
    <div className="container-fluid animate pageWrapper">
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>AVANTAJLAR</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="#">AVANTAJLAR</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}

        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textCapsule">
                <h2 className="title">
                  <b>Shell Taşıt Tanıma Sistemi</b>
                  <br />
                  <span className="red big">
                    <b>AVANTAJLARI</b>
                  </span>
                </h2>
                <p>
                  Shell Taşıt Tanıma Sistemi'nin online platformu sayesinde,
                  bulunduğunuz yerden filonuzun tüm yönetim işlemlerini kolayca
                  gerçekleştirebilir ve sistemin sunduğu ayrıcalıklardan
                  yararlanabilirsiniz.
                </p>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row mt-3 start-sm center-xs">
              {/* <!--urun--> */}
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <img src={ImgTTS} height="263" width="375" />
                  </span>
                </div>
              </div>
              {/* <!--/urun--> */}
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div className="textCapsule">
                  <h4>Hızlı ve Kolay Yakıt Alımı</h4>
                  <p>
                    Akaryakıt istasyonlarında zaman kaybetmeden, anında yakıt
                    dolumu yapabilirsiniz.
                  </p>

                  <h4>Toplu ve Pratik Ödeme</h4>
                  <p>
                    Tüm yakıt ödemelerinizi tek bir merkezden, topluca ve
                    kolayca gerçekleştirebilirsiniz.
                  </p>

                  <h4>Muhasebede Zaman Tasarrufu</h4>
                  <p>
                    Aylık olarak düzenlenen toplu faturalar sayesinde muhasebe
                    ve idari işlemlerinizde büyük kolaylık sağlanır.
                  </p>

                  <h4>Türkiye Genelinde Yaygın Hizmet Noktaları</h4>
                  <p>
                    Ülke çapında 1000'den fazla Shell istasyonu Taşıt Tanıma
                    Sistemi ile donatılmıştır. Şifre almak için kurumsal e-posta
                    adresinizden{" "}
                    <a href="malto:info@kit-tak.com">info@kit-tak.com</a>{" "}
                    adresine başvurmanız yeterlidir.
                  </p>

                  <h4>Shell TTS Online Platformu ile Kolay Yönetim</h4>
                  <p>
                    Akaryakıt tüketiminizi yönetmenin en pratik ve verimli
                    yoludur.
                    <br /> Araçlarınızla ilgili tüm işlemlere 7/24 erişim imkânı
                    sunan gelişmiş bir online yakıt yönetim sistemi sağlar.
                    <br /> Yakıt harcamalarınızı TTS Online üzerinden kolayca
                    planlayıp yönetebilirsiniz.
                    <br /> Şifre almak için kurumsal e-posta adresinizden{" "}
                    <a href="malto:info@kit-tak.com">info@kit-tak.com</a>{" "}
                    adresine başvurmanız yeterlidir.
                  </p>

                  <h4>Shell TTS web platformunda yapabilecekleriniz:</h4>
                  <h4>1) YÖNETİM VE KONTROL</h4>
                  <p>
                    • Araç, departman veya filo bazında limitler
                    belirleyebilirsiniz.
                    <br /> • Araçlarınızın günlük, haftalık veya aylık tüketim
                    miktarlarını ve yakıt alım günlerini siz seçebilirsiniz.
                    <br /> • İnternet üzerinden araçlarınızın yakıt alımını
                    anında açıp kapatabilirsiniz.
                  </p>
                  <h4>2) ONLINE RAPORLAMA</h4>
                  <p>
                    • Araç veya departman bazında detaylı tüketim raporları
                    alabilirsiniz.
                    <br /> • Her yakıt alımı için ayrıntılı bilgiye
                    ulaşabilirsiniz.
                    <br /> • Filo ve araç bazında limit ve tüketim verilerini
                    görebilirsiniz.
                    <br /> • Araç verimliliği için litre/TL oranlarını
                    inceleyebilirsiniz.
                    <br /> • Tüm raporları kolayca bilgisayarınıza
                    indirebilirsiniz.
                  </p>
                </div>
              </div>
            </div>
            {/* <!--/urunler--> */}
          </div>
        </div>
        {/* <!--/page--> */}
      </div>
      {/* <!--//Page--> */}
    </div>
  );
}
